import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { ChatbotModule } from './chatbot/chatbot.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { SidenavComponent } from './navs/sidenav/sidenav.component';
import { NavbarComponent } from './navs/navbar/navbar.component';
import { BlListaComponent } from './pages/bl-lista/bl-lista.component';
import { BlDetalleComponent } from './pages/bl-detalle/bl-detalle.component';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { SharedModule } from './shared/shared.module';
import { ReadXlsxComponent } from './pages/read-xlsx/read-xlsx.component';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { Rule238Component } from './components/rule238/rule238.component';
import { Rule238FormComponent } from './components/rule238-form/rule238-form.component';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: environment.cognito.oauth.domain,
          redirectSignIn: [environment.cognito.oauth.redirectSignIn],
          redirectSignOut: [environment.cognito.oauth.redirectSignOut],
          responseType: 'code',
          scopes: ['openid','email','phone','profile','aws.cognito.signin.user.admin'],
        },
        username: true,
        email: false, // Optional
        phone: false, // Optional
      },
    },
  },
  Geo: {
    LocationService: {
      region: environment.cognito.region
    }
  }
});

@NgModule({
  declarations: [
    // App
    AppComponent,

    // Pages
    LoginComponent,
    BlListaComponent,
    BlDetalleComponent,
    ReadXlsxComponent,

    // Components
    Rule238Component,
    Rule238FormComponent,
    SidenavComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,

    ChatbotModule,

    SharedModule,

    FormsModule,
    ReactiveFormsModule,

    AmplifyAuthenticatorModule,

    HttpClientModule,
    RouterModule
  ],
  providers: [
    // Interceptors
    // Add Authorization header to all requests
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Cath Missing authorization header
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
